import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import HubspotForm from './HubSpotForm';

function Contact({ source }) {
    const isInvestor = source === 'investor';

    return (
        <Container className="text-center text-white d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
            <Row className="justify-content-center">
                <Col md={8} lg={6} className="p-5 rounded-4 text-start" style={{ backgroundColor: 'rgba(255, 255, 255, 0.05)', border: '1px solid rgba(255, 255, 255, 0.1)' }}>
                    <h2 className="mb-4 fw-bold text-center">Let's Talk</h2>
                    <p className="lead mb-4" style={{ lineHeight: '1.8' }}>
                        {isInvestor
                            ? "We'd love to share more about what we're building and where we're headed. Tell us a bit about yourself and we'll be in touch."
                            : "A small group of teams are already building with Qcoda in early access. If your team writes specs before you write code — or wishes you did — let's talk."
                        }
                    </p>
                    <p className="lead m-0 mb-4" style={{ lineHeight: '1.8' }}>
                        You can also reach us at <a href="mailto:hello@qcoda.com" className="text-white fw-bold text-decoration-underline underline-offset-4">hello@qcoda.com</a>
                    </p>

                    <div className="form-contact" style={{ backgroundColor: '#f5f7fa', borderRadius: '8px', padding: '1.5rem', color: '#333' }}>
                        <HubspotForm
                            portalId='245090272'
                            formId='02f60fbd-6612-4d7b-a39d-4aa916411e96'
                        />
                    </div>

                </Col>
            </Row>
        </Container>
    );
}

export default Contact;
